import React from 'react';
import { FormGroup, FormLabel, FormHint, FormError } from './form-group';
import { Select } from './newSelect';
import { cn } from 'src/lib/utils';

const SelectField = React.forwardRef(function SelectField(
  {
    label,
    id,
    hint,
    error,
    options = [],
    value,
    onChange,
    placeholder = 'Select...',
    multiple = false,
    searchable = false,
    clearable = false,
    disabled = false,
    className,
    ...selectProps
  },
  ref,
) {
  const fieldId = id || `select-${Math.random().toString(36).slice(2, 9)}`;
  return (
    <FormGroup className={cn(className)} ref={ref}>
      {label && <FormLabel htmlFor={fieldId}>{label}</FormLabel>}
      <Select
        options={options}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        multiple={multiple}
        searchable={searchable}
        clearable={clearable}
        disabled={disabled}
        className={cn(error && 'border-destructive ring-destructive/12')}
        {...selectProps}
      />
      {hint && !error && <FormHint>{hint}</FormHint>}
      {error && <FormError>{error}</FormError>}
    </FormGroup>
  );
});

export { SelectField };
